<div class="header">
  <div>
    <h2>{{ 'tokenAnalytics.title' | translate }}</h2>
  </div>
  <app-page-help>{{ 'tokenAnalytics.subtitle' | translate }}</app-page-help>
</div>

<!-- Drei Sichten auf dieselbe Frage — was KI kostet und wie wir sie steuern:
     die Token-Oekonomie aus LangSmith, der Deckungsbeitrag der Credits und das
     Routing Aufgabe -> Modell mit Vergleichslaeufen. Reiter wie auf
     „Organisation" (nb-tabset, Stand in ?tab=). -->
<nb-tabset (changeTab)="onTabChange($event.tabId)">
  <nb-tab tabId="tokens" [active]="activeTab === 'tokens'"
          [tabTitle]="'tokenAnalytics.tabs.tokens' | translate" tabIcon="activity-outline">
      <div class="controls tab-toolbar">
        <nb-select
          size="small"
          [selected]="selectedProject"
          (selectedChange)="onProjectChange($event)"
          *ngIf="projects.length > 1"
        >
          <nb-option *ngFor="let p of projects" [value]="p">{{ p }}</nb-option>
        </nb-select>
        <nb-select
          size="small"
          [selected]="windowDays"
          (selectedChange)="onWindowChange($event)"
        >
          <nb-option *ngFor="let w of windowOptions" [value]="w">
            {{ 'tokenAnalytics.window.days' | translate: { days: w } }}
          </nb-option>
        </nb-select>
        <button
          nbButton
          status="primary"
          size="small"
          (click)="refresh()"
          [disabled]="isRefreshing"
          [nbSpinner]="isRefreshing"
          nbSpinnerSize="tiny"
        >
          <nb-icon icon="refresh-outline"></nb-icon>
          {{ (isRefreshing ? 'tokenAnalytics.refreshing' : 'tokenAnalytics.refresh') | translate }}
        </button>
      </div>

    <p class="page-hint" *ngIf="lastFetchedAt">
      {{ 'tokenAnalytics.lastUpdated' | translate }}
      {{ lastFetchedAt | date: 'dd.MM.yyyy HH:mm' }}
      · {{ 'tokenAnalytics.source' | translate }}
    </p>
    <p class="page-hint" *ngIf="refreshFailed">
      ⚠️ {{ 'tokenAnalytics.refreshFailed' | translate }}
    </p>

    <div [nbSpinner]="isLoading" nbSpinnerStatus="primary">
      <!-- Empty state: no snapshot yet -->
      <nb-card *ngIf="!isLoading && rows.length === 0">
        <nb-card-body class="empty-state">
          <p>{{ 'tokenAnalytics.empty' | translate }}</p>
        </nb-card-body>
      </nb-card>

      <ng-container *ngIf="rows.length > 0">
        <!-- KPI row -->
        <div class="kpi-grid" *ngIf="primaryAgent as pa">
          <nb-card class="kpi-card">
            <nb-card-header>
              {{ 'tokenAnalytics.kpi.median' | translate: { agent: pa.agent_type } }}
            </nb-card-header>
            <nb-card-body>
              <div class="card-value">{{ pa.p50_total | number: '1.0-0' }}</div>
              <div class="kpi-unit">Tokens · ~${{ pa.p50_cost | number: '1.4-4' }}</div>
            </nb-card-body>
          </nb-card>
          <nb-card class="kpi-card">
            <nb-card-header>{{ 'tokenAnalytics.kpi.mean' | translate }}</nb-card-header>
            <nb-card-body>
              <div class="card-value">{{ pa.mean_total | number: '1.0-0' }}</div>
              <div class="kpi-unit">Tokens · ~${{ pa.mean_cost | number: '1.4-4' }}</div>
            </nb-card-body>
          </nb-card>
          <nb-card class="kpi-card">
            <nb-card-header>{{ 'tokenAnalytics.kpi.p99' | translate }}</nb-card-header>
            <nb-card-body>
              <div class="card-value">{{ pa.p99_total | number: '1.0-0' }}</div>
              <div class="kpi-unit">Tokens · ~${{ pa.p99_cost | number: '1.4-4' }}</div>
            </nb-card-body>
          </nb-card>
          <nb-card class="kpi-card">
            <nb-card-header>{{ 'tokenAnalytics.kpi.totalCost' | translate }}</nb-card-header>
            <nb-card-body>
              <div class="card-value">${{ totalCost | number: '1.2-2' }}</div>
              <div class="kpi-unit">{{ selectedProject }}</div>
            </nb-card-body>
          </nb-card>
        </div>

        <!-- Distribution (log scale p50 → p99) -->
        <nb-card>
          <nb-card-header>
            <h5>{{ 'tokenAnalytics.distribution.title' | translate }}</h5>
          </nb-card-header>
          <nb-card-body>
            <div class="axis">
              <div class="tick" *ngFor="let t of axisTicks" [style.left.%]="t.pos">
                {{ t.label }}
              </div>
            </div>
            <div class="dist-row" *ngFor="let d of distributionRows">
              <div class="name">
                {{ d.row.agent_type }}
                <span class="n2">{{ d.row.runs | number }} Runs</span>
              </div>
              <div class="track-wrap">
                <div class="track"></div>
                <div class="range" [style.left.%]="d.left" [style.width.%]="d.width"></div>
                <div class="mk p99" [style.left.%]="d.left + d.width"
                     [title]="'p99 ' + (d.row.p99_total | number)"></div>
                <div class="mk p50" [style.left.%]="d.left"
                     [title]="'Median ' + (d.row.p50_total | number)"></div>
                <div class="mk mean" [style.left.%]="d.meanPos"
                     [title]="'Mean ' + (d.row.mean_total | number)"></div>
                <ng-container *ngIf="d.row.gt_500k > 0">
                  <div class="mk tail" [style.left.%]="d.tailPos"
                       [title]="d.row.gt_500k + ' Runs >500k'"></div>
                  <div class="tail-count" [style.left.%]="d.tailPos">{{ d.row.gt_500k }}</div>
                </ng-container>
              </div>
            </div>
            <div class="legend">
              <span><i class="swatch p50"></i> {{ 'tokenAnalytics.distribution.median' | translate }}</span>
              <span><i class="swatch mean"></i> {{ 'tokenAnalytics.distribution.mean' | translate }}</span>
              <span><i class="swatch p99"></i> p99</span>
              <span><i class="swatch tail"></i> {{ 'tokenAnalytics.distribution.outliers' | translate }}</span>
              <span class="legend-note">{{ 'tokenAnalytics.distribution.note' | translate }}</span>
            </div>
          </nb-card-body>
        </nb-card>

        <!-- Size-class histogram -->
        <nb-card>
          <nb-card-header>
            <h5>{{ 'tokenAnalytics.histogram.title' | translate }}</h5>
          </nb-card-header>
          <nb-card-body>
            <div class="hist-row" *ngFor="let r of rows">
              <div class="name">{{ r.agent_type }}</div>
              <div class="bar">
                <div
                  class="seg {{ s.cls }}"
                  *ngFor="let s of histogram(r)"
                  [style.width.%]="s.pct"
                  [title]="s.label + ': ' + s.count + ' Runs'"
                ></div>
              </div>
              <span class="hot" [class.zero]="r.gt_40k === 0">{{ r.gt_40k }}</span>
            </div>
            <div class="hist-legend">
              <span><i class="b0"></i> &lt;20k</span>
              <span><i class="b1"></i> 20–40k</span>
              <span><i class="b2"></i> 40–100k</span>
              <span><i class="b3"></i> 100–500k</span>
              <span><i class="b4"></i> &gt;500k</span>
              <span class="legend-note">{{ 'tokenAnalytics.histogram.note' | translate }}</span>
            </div>
          </nb-card-body>
        </nb-card>

        <!-- Full table -->
        <nb-card>
          <nb-card-header>
            <h5>{{ 'tokenAnalytics.table.title' | translate }}</h5>
          </nb-card-header>
          <nb-card-body class="tbl-scroll">
            <table>
              <thead>
                <tr>
                  <th>{{ 'tokenAnalytics.table.agent' | translate }}</th>
                  <th>Runs</th>
                  <th>{{ 'tokenAnalytics.table.median' | translate }}</th>
                  <th>{{ 'tokenAnalytics.table.mean' | translate }}</th>
                  <th>p99</th>
                  <th>Ø In</th>
                  <th>Ø Out</th>
                  <th>&gt;40k</th>
                  <th>&gt;100k</th>
                  <th>&gt;500k</th>
                  <th>Σ $</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let r of rows">
                  <td>{{ r.agent_type }}</td>
                  <td>{{ r.runs | number }}</td>
                  <td>{{ r.p50_total | number }}</td>
                  <td>{{ r.mean_total | number }}</td>
                  <td>{{ r.p99_total | number }}</td>
                  <td>{{ r.p50_in | number }}</td>
                  <td>{{ r.p50_out | number }}</td>
                  <td [class.hot]="r.gt_40k > 0">{{ r.gt_40k }}</td>
                  <td [class.hot]="r.gt_100k > 0">{{ r.gt_100k }}</td>
                  <td [class.hot]="r.gt_500k > 0">{{ r.gt_500k }}</td>
                  <td>${{ r.total_cost | number: '1.2-2' }}</td>
                </tr>
              </tbody>
            </table>
          </nb-card-body>
        </nb-card>
      </ng-container>
    </div>
  </nb-tab>

  <nb-tab tabId="margin" [active]="activeTab === 'margin'"
          [tabTitle]="'tokenAnalytics.tabs.margin' | translate" tabIcon="trending-up-outline">
    <app-margin-report *ngIf="activeTab === 'margin'"></app-margin-report>
  </nb-tab>

  <nb-tab tabId="routing" [active]="activeTab === 'routing'"
          [tabTitle]="'tokenAnalytics.tabs.routing' | translate" tabIcon="shuffle-2-outline">
    <app-ai-routing *ngIf="activeTab === 'routing'"></app-ai-routing>
  </nb-tab>
</nb-tabset>
